/* fndry-blog-posts
   One job: keep the mobile scroll indicator in step with the rail. The rail
   itself is native scroll-snap and needs no JS — if this file never runs, the
   bar still renders at its correct rest state from --bp-count. */

(function () {
  'use strict';

  var SECTION = '[data-fndry-bp]';
  var READY = 'bpReady';

  function BlogRail(root) {
    this.root = root;
    this.rail = root.querySelector('[data-bp-rail]');
    this.bar = root.querySelector('[data-bp-bar]');
    this.thumb = root.querySelector('[data-bp-thumb]');

    if (!this.rail || !this.bar || !this.thumb) return;

    this.items = Array.prototype.slice.call(this.rail.children);
    if (!this.items.length) return;

    /* One query, negated. Never matchMedia('(max-width: 749px)') — at 749.5px
       neither matches and the JS would disagree with the stylesheet. */
    this.mq = window.matchMedia('(min-width: 750px)');
    this.pages = this.items.length;
    this.frame = null;
    this.vw = document.documentElement.clientWidth;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onBreakpoint = this.onBreakpoint.bind(this);

    this.rail.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.onBreakpoint);
    } else if (this.mq.addListener) {
      this.mq.addListener(this.onBreakpoint);
    }

    this.measure();
    this.update();
  }

  BlogRail.prototype.isMobile = function () {
    return !this.mq.matches;
  };

  BlogRail.prototype.measure = function () {
    var overflow = this.rail.scrollWidth - this.rail.clientWidth;

    if (!this.isMobile() || overflow < 2) {
      this.bar.hidden = true;
      return;
    }

    this.bar.hidden = false;

    /* Pages are measured, not hardcoded, so this stays right if the card count
       or the visible-per-page count ever changes. */
    var stride;
    if (this.items.length > 1) {
      stride =
        this.items[1].getBoundingClientRect().left -
        this.items[0].getBoundingClientRect().left;
    } else {
      stride = this.items[0].getBoundingClientRect().width;
    }
    if (!stride || stride < 1) stride = this.rail.clientWidth;

    var perPage = Math.max(1, Math.round(this.rail.clientWidth / stride));
    this.pages = Math.max(1, Math.ceil(this.items.length / perPage));
    this.root.style.setProperty('--bp-count', String(this.pages));
  };

  BlogRail.prototype.update = function () {
    if (this.bar.hidden) return;

    var max = this.rail.scrollWidth - this.rail.clientWidth;
    var p = max > 0 ? this.rail.scrollLeft / max : 0;
    if (p < 0) p = 0;
    if (p > 1) p = 1;

    var trackWidth = this.bar.clientWidth;
    var thumbWidth = trackWidth / this.pages;

    this.thumb.style.transform =
      'translateX(' + p * (trackWidth - thumbWidth) + 'px)';
  };

  BlogRail.prototype.onScroll = function () {
    if (this.frame) return;
    var self = this;
    this.frame = window.requestAnimationFrame(function () {
      self.frame = null;
      self.update();
    });
  };

  /* P15 sitewide 2026-10-23: a resize that keeps the width is the phone
     toolbar collapsing or coming back - the rail does not depend on height. */
  BlogRail.prototype.onResize = function () {
    if (this.resizeFrame) return;
    var self = this;
    this.resizeFrame = window.requestAnimationFrame(function () {
      self.resizeFrame = 0;
      var w = document.documentElement.clientWidth;
      if (w === self.vw) return;
      self.vw = w;
      self.measure();
      self.update();
    });
  };

  BlogRail.prototype.onBreakpoint = function () {
    this.measure();
    this.update();
  };

  BlogRail.prototype.reveal = function (item) {
    if (!item || !this.isMobile()) return;
    var railBox = this.rail.getBoundingClientRect();
    var itemBox = item.getBoundingClientRect();
    this.rail.scrollTo({
      left: this.rail.scrollLeft + (itemBox.left - railBox.left),
      behavior: 'smooth'
    });
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll(SECTION);
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset[READY] === 'true') return;
      root.dataset[READY] = 'true';
      try {
        root.fndryBlogRail = new BlogRail(root);
      } catch (err) {
        root.dataset[READY] = 'false';
        if (window.console) console.warn('fndry-blog-posts:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest(SECTION);
    if (root && root.fndryBlogRail) root.fndryBlogRail.reveal(e.target);
  });
})();